<template>
  <b-form-group :label="properties.label">
    <div class="border rounded border-color-light-gray">
      <div class="bg-light-gray py-2 px-3">
        <b-form-textarea
          v-model="form.text"
          rows="4"
          no-resize
          class="mb-2"
          :errors="formErrors.text"
          :placeholder="properties.placeholders.textarea"
        />
        <b-input-group class="d-flex">
          <template v-slot:append>
            <b-button
              size="sm"
              variant="primary"
              class="text-white"
              style
              @click="addWeightedText"
            >
              Add
            </b-button>
          </template>
          <b-input
            type="number"
            v-model="form.value"
            size="sm"
            :errors="formErrors.vaule"
            :placeholder="properties.placeholders.input"
          ></b-input>
        </b-input-group>
      </div>
      <div class="texts-list-container">
        <b-list-group v-if="value.length > 0" class="mt-1 p-1 forms-list">
          <draggable v-model="propertyValue">
            <b-list-group-item
              class="filter-value border pl-2 pr-2 pt-1 pb-1 mr-2 ml-1 mt-2"
              v-for="({ text, value }, index) in value"
              :key="index"
            >
              <div>
                <b-icon-grip-horizontal></b-icon-grip-horizontal>
                {{ text }} ({{ value }})
              </div>
              <img
                class="filter-value-delete"
                :src="require('../../../assets/icons/close-circle.png')"
                @click="removeText(index)"
              />
            </b-list-group-item>
          </draggable>
        </b-list-group>
        <div v-else class="text-center color-custom-dark-grey m-1">
          No items selected.
        </div>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  name: "MultipleWeightedTextPropertyType",
  components: { Draggable },
  props: ["properties", "property", "value"],
  data() {
    return {
      form: {
        text: "",
        value: ""
      },
      formErrors: {
        text: [],
        value: []
      }
    };
  },
  methods: {
    addWeightedText() {
      if (this.form.text.trim() && this.form.value) {
        const newWeightedTexts = [...this.value];
        newWeightedTexts.push({
          text: this.form.text,
          value: parseFloat(this.form.value)
        });
        this.$emit("update-value", this.property, newWeightedTexts);
        this.form = { text: "", value: "" };
      }
    },
    removeText(itemIndex) {
      const newValue = [...this.value];
      newValue.splice(itemIndex, 1);
      this.$emit("update-value", this.property, newValue);
    }
  },
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-value", this.property, newValue);
      }
    }
  }
};
</script>

<style scoped>
.texts-list-container {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filter-value {
  position: relative;
  min-width: 50px;
  color: #a6a6a6;
  font-size: 14px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
</style>
